import { __rest, __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-tables.css';
import { UitkTableCaptionAlignment } from './types.esm.js';

var getClassNameList = classNames.bind(styles);
var UitkTableCaption = function (props) {
    var align = props.align, children = props.children, className = props.className, attributes = __rest(props, ["align", "children", "className"]);
    var baseClassName = 'uitk-table-caption';
    var captionClassNames = getClassNameList(baseClassName, className, align && "".concat(baseClassName, "-").concat(UitkTableCaptionAlignment.get(align)));
    return children ? (React.createElement("caption", __assign({ className: captionClassNames }, attributes), children)) : null;
};
UitkTableCaption.displayName = 'UitkTableCaption';
UitkTableCaption.defaultProps = {
    align: UitkTableCaptionAlignment.get('start')
};

export { UitkTableCaption };
